import { NgModule, Optional, SkipSelf, ModuleWithProviders, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { DataService } from './services/data.service';
import { UtilityService } from './services/utility.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {InterceptorService} from './services/interceptor.service';
import { LoaderService } from '../shared/services/loader.service';


@NgModule({
    imports: [CommonModule],
    exports: [],
    providers: []
})
export class CoreModule {
    public static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                Title,
                UtilityService,
                DataService,
                { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
                LoaderService
            ]
        };
    }
    constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
}
